import { Module } from 'vuex'
import { GlobalDataProps, actionWrapper } from './index'
import { ListData, RespData } from './respTypes'
export interface ThemeProps {
  name: string;
  display: string;
  hex: string;
}
export interface TemplateData {
  _id: string;
  name: string;
  componentName: string;
  themes: ThemeProps[];
  coverImage?: string;
  title?: string;
  desc?: string;
  columns: string;
  publicLink: string;
  isPro?: boolean;
}
export interface TemplateProps {
  data: TemplateData[];
  selectedId: string;
  isLoaded: boolean;
}
const templates: Module<TemplateProps, GlobalDataProps> = {
  state: {
    data: [],
    selectedId: '',
    isLoaded: false
  },
  mutations: {
    getTemplates(state, rawData: ListData<TemplateData[]>) {
      const { data } = rawData
      state.data = data.data
      state.isLoaded = true
    },
    createTemplate(state, rawData: RespData<TemplateData>) {
      const { data } = rawData
      state.data.push(data)
    },
    updateTemplate(state, rawData: RespData<TemplateData>) {
      const { data } = rawData
      const index = state.data.findIndex(template => template._id === data._id)
      if (index > -1) {
        state.data[index] = data
      }
    },
    deleteTemplate(state, { payload }: RespData<any>) {
      if (payload && payload.urlParams) {
        const { urlParams } = payload
        state.data = state.data.filter(template => template._id !== urlParams.id)
      }      
    },
    selectTemplate(state, id: string) {
      state.selectedId = id
    }
  },
  actions: {
    getTemplates: actionWrapper('/api/templates', 'getTemplates'),
    createTemplate: actionWrapper('/api/templates', 'createTemplate', { method:'POST' }),
    updateTemplate: actionWrapper('/api/templates/:id', 'updateTemplate', { method: 'patch', disableCaching: true }),
    deleteTemplate: actionWrapper('/api/templates/:id', 'deleteTemplate', { method: 'delete', disableCaching: true })
  }
}

export default templates